import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "../../../util/asyncComponent";

const Form = ({ match }) => (
  <Switch>
    <Redirect exact from={`${match.url}/`} to={`${match.url}/manuales`} />

    <Route
      path={`${match.url}/list-manuales`}
      component={asyncComponent(() => import("./routes/list-manuales"))}
    />

    <Route
      path={`${match.url}/detail/:id`}
      component={asyncComponent(() => import("./routes/manual-detail"))}
    />

    <Route
      component={asyncComponent(() =>
        import("app/routes/extraPages/routes/404")
      )}
    />
  </Switch>
);

export default Form;



// WEBPACK FOOTER //
// ./app/routes/manuales/index.js